// extracted by css-extract-rspack-plugin
export default {"postChangeModalContent":"post-change-modal-content--RGgZCpVogVUunCQB"};